<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data)">
        <span>{{ checkStatus(params.data) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: 'CellRendererStatus',
    computed: {
        chipColor() {
            return value => {
                if (value.status == 1) {
                    return "warning"
                } else if (value.status == 2) {
                    return "success"
                } 
            }
        },
        checkStatus() {
            return value => {
                if (value.status == 1) {
                    return 'Chờ xử lý'
                } else if (value.status == 2) {
                    return 'Đã xử lý'
                }
            }
        }
    }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .15);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }
}
</style>
